import { FuseLoadable } from "@fuse";

export const HelpConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes: [
        {
            path: "/help",
            component: FuseLoadable({
                loader: () => import("./HelpApp")
            })
        },
    ]
};
